module.exports = __webpack_public_path__ + "static/email-min-832927b04291c9ed1f6a32cc13846195.jpg";